type GroupMap<T extends any> = Record<string | number, T[]>;

export const groupBy = <
  T extends any
>(
  array: T[],
  fn: (item: T) => string | number
): GroupMap<T> => {
  const groups = {};

  for (const item of array) {
    const key = fn(item);
    groups[key] = groups[key] || [];
    groups[key].push(item);
  }

  return groups;
};



// WEBPACK FOOTER //
// ./src/utils/arrayUtils.ts